import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/lib/auth';
import { RequireAuth } from '@/lib/RequireAuth';
import { Toaster } from 'sonner';
import '@/i18n';

import CatalogPage from '@/pages/Catalog';import ProductDetailPage from '@/pages/ProductDetail';
import RequestPage from '@/pages/Request';
import LoginPage from '@/pages/Login';
import PortalDashboard from '@/pages/PortalDashboard';
import MyRequestsPage from '@/pages/MyRequests';

import { AdminLayout } from '@/components/AdminLayout';
import AdminOverview from '@/pages/admin/AdminOverview';
import AdminProducts from '@/pages/admin/AdminProducts';
import AdminUsers from '@/pages/admin/AdminUsers';
import AdminSync from '@/pages/admin/AdminSync';
import AdminAudit from '@/pages/admin/AdminAudit';
import AdminErrors from '@/pages/admin/AdminErrors';
import AdminRequests from '@/pages/admin/AdminRequests';
import AdminNotifications from '@/pages/admin/AdminNotifications';

function PortalCatalog() { return <CatalogPage portal />; }
function PortalProduct() { return <ProductDetailPage portal />; }

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CatalogPage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/request/:id" element={<RequestPage />} />
          <Route path="/login" element={<LoginPage />} />

          <Route path="/portal" element={<RequireAuth><PortalDashboard /></RequireAuth>} />
          <Route path="/portal/catalog" element={<RequireAuth><PortalCatalog /></RequireAuth>} />
          <Route path="/portal/product/:id" element={<RequireAuth><PortalProduct /></RequireAuth>} />
          <Route path="/portal/requests" element={<RequireAuth><MyRequestsPage /></RequireAuth>} />

          <Route path="/admin" element={<RequireAuth admin><AdminLayout /></RequireAuth>}>
            <Route index element={<AdminOverview />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="sync" element={<AdminSync />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="errors" element={<AdminErrors />} />
            <Route path="requests" element={<AdminRequests />} />
            <Route path="notifications" element={<AdminNotifications />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
